"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = logGroup;

/* eslint-disable no-console */
function logGroup(groupMessage, groupBody, groupNote) {
  var groupMessageStyle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

  if (groupBody == null) {
    console.log('%c%s', 'font-weight:bold', groupMessage);
  } else {
    if (groupNote != null) {
      console.groupCollapsed("%c%s%c%s", "font-weight:bold;".concat(groupMessageStyle), groupMessage, 'font-weight:normal', " - ".concat(groupNote));
    } else {
      console.groupCollapsed("%c%s", "font-weight:bold;".concat(groupMessageStyle), groupMessage);
    }

    groupBody();
    console.groupEnd();
  }
}